import * as React from 'react'
import { requestIdleCallbackPonyfill } from './dom'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Type = React.ComponentType<any>

export function lazyComponent<T extends Type>(component: () => Promise<T>) {
  const loader = () => component().then(t => ({ default: t }))
  return {
    component: React.lazy(loader),
    preload: () => {
      requestIdleCallbackPonyfill(() => {
        // The idle callback can outlive the caller. A rejection here is unhandled,
        // and rendering loads the module again.
        void loader().catch(() => undefined)
      })
    },
  }
}

export type LazyComponent = ReturnType<typeof lazyComponent>
